// @helpers
const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');

// @utilities
const { APIGet } = require('utilities/APIRequestHelper');

function requestCheckingAccountsIntervenersRequest() {
    return {
        type: actionTypes.BROKER_FETCH_CHECKING_ACCOUNTS_INTERVENERS_REQUEST
    };
}

function requestCheckingAccountsIntervenersSuccess(accountId, response) {
    return {
        type: actionTypes.BROKER_FETCH_CHECKING_ACCOUNTS_INTERVENERS_SUCCESS,
        payload: {
            accountId,
            interveners: response.intervinientes.interviniente
        }
    };
}

function requestCheckingAccountsIntervenersFailure(response) {
    return {
        type: actionTypes.BROKER_FETCH_CHECKING_ACCOUNTS_INTERVENERS_FAILURE,
        payload: {
            data: response
        }
    };
}

function requestCheckingAccountInterveners(account) {
    return function(dispatch) {
        const requestData = {
            query: {
                numeroContrato: account.getIn(['contract', 'number']),
                producto: account.getIn(['contract', 'product']),
                saldo: account.getIn(['balance', 'amount'])
            }
        };

        dispatch(requestCheckingAccountsIntervenersRequest());
        return APIGet(dispatch, apiURLBuilder.getURL('brokerCheckingAccountsInterveners'), requestData)
            .then(function(response) {
                dispatch(requestCheckingAccountsIntervenersSuccess(account.get('accountId'), response));
            }, function(response) {
                dispatch(requestCheckingAccountsIntervenersFailure(response));
            }
        );
    };
}

module.exports = {
    requestCheckingAccountInterveners
}
